import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Ui::Link\n  @route=\'routes/company-settings.users.show\'\n  @model={{@record.email}}\n  data-test-user-show-details={{@record.email}}\n>\n  {{t \'Details\'}}\n</Ui::Link>")